import WarningIcon from "@mui/icons-material/Warning";
import { Box, Tooltip } from "@mui/material";
import type { Property } from "csstype";
import type { FC, ReactNode } from "react";
import { STATUS } from "../../theme/tokens";

type Props = {
	violation: ReactNode;
	displayViolation: boolean;
	fontSize?: Property.FontSize;
	color?: string;
	children?: ReactNode;
	gap?: Property.Gap;
	renderIconWhenNoViolation?: boolean;
};

export const WarningViolation: FC<Props> = ({
	displayViolation,
	violation,
	fontSize = 18,
	color = STATUS.WARNING.main,
	children,
	gap = 1,
	renderIconWhenNoViolation = true,
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "baseline",
				justifyContent: "center",
				gap: children ? gap : 0,
			}}
		>
			{children}
			{(displayViolation || renderIconWhenNoViolation) && (
				<Tooltip title={violation} disableHoverListener={!displayViolation}>
					<WarningIcon
						style={{
							color: color,
							fontSize: fontSize,
							opacity: displayViolation ? 1 : 0,
						}}
					/>
				</Tooltip>
			)}
		</Box>
	);
};
